import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {Page} from '@/lib/page'
import type {components} from '@/lib/api-schema'

export type Verificacion = components['schemas']['VerificacionIdentidadRead']

export const VERIFICACIONES_PAGE_SIZE = 20

const KEY = ['admin-verificaciones-identidad']

export function useVerificaciones(page: number, enabled = true) {
  return useQuery({
    queryKey: [...KEY, page],
    queryFn: async () =>
      (
        await api.get<Page<Verificacion>>('/admin/verificaciones-identidad', {
          params: {page, page_size: VERIFICACIONES_PAGE_SIZE},
        })
      ).data,
    enabled,
    placeholderData: (previous) => previous,
  })
}

/** Aprobar libera la membresía y las de la misma persona en otras empresas: refresca la cola y las cuentas. */
export function useResolverVerificacion() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({id, motivo}: {id: string; motivo?: string}) =>
      (
        await api.post<Verificacion>(
          `/admin/verificaciones-identidad/${id}/${motivo === undefined ? 'aprobar' : 'rechazar'}`,
          motivo === undefined ? undefined : {motivo}
        )
      ).data,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: KEY})
      queryClient.invalidateQueries({queryKey: ['admin-usuarios']})
    },
    meta: {manejaError: true},
  })
}
